import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DomService {
  private dom: Document | null = null;
  private win: Window | null = null;

  constructor() {
    this.dom = document;
    this.win = window;
  }

  getDocument(): Document {
    return this.dom ? this.dom : ({} as Document);
  }

  getWindow(): Window {
    return this.win ? this.win : ({} as Window);
  }

  openWindow(url: string, target: string, feature: string) {
    this.win.open(url, target, feature);
  }

  location(url: string) {
    this.dom.location.href = url;
  }
}
